import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable @typescript-eslint/ban-types */
import Vue from 'vue';
import yodaBridge from '@ks/yoda-js-sdk';
import Cookies from 'js-cookie';
import { encodeURI } from 'js-base64';
import { isIOS } from '@/utils/env';
import Toast from '@/components/toast';
import { getMaskPhone } from '@/services/balance';
import { getUserCountryByUid } from '@/services/common';
import { logger } from '@/common/log';
import { IJumpType, userId } from './const';
import { getEnv } from './env';
var fn = function fn() {
  return Promise.resolve();
};
var eventMap = {};
if (!yodaBridge.isInYoda) {
  yodaBridge.ready = function () {
    return Promise.resolve();
  };
  // mock yodaBridge when it's not in yoda
  yodaBridge.webview = {
    open: function open(options) {
      return new Promise(function (resolve) {
        if (!(options !== null && options !== void 0 && options.url)) {
          resolve(undefined);
          return;
        }
        // 端外打开处理 url
        var urlArr = options.url.split(/[?&]/).filter(function (item) {
          return !item.includes('webview=');
        });
        urlArr[0] += '?source=transfer';
        var url = urlArr.join('&');
        // window.open 会被拦截
        setTimeout(function () {
          var openRes = window.open(url, '_blank');
          // open 可能会被拦截
          if (!openRes) {
            window.location.href = url;
          } else if (options.needClose) {
            window.close();
          }
          resolve(undefined);
        }, 800);
      });
    },
    getLaunchParams: function getLaunchParams() {
      return Promise.resolve();
    },
    close: function close() {
      return new Promise(function (resolve) {
        window.close();
        resolve(undefined);
      });
    },
    backOrClose: function backOrClose() {
      return Promise.resolve();
    }
  };
  yodaBridge.event = {
    addEventListener: function addEventListener(type, listener, callback) {
      return new Promise(function (resolve) {
        eventMap[type] = eventMap[type] ? [].concat(_toConsumableArray(eventMap[type]), [listener]) : [listener];
        callback === null || callback === void 0 ? void 0 : callback();
        resolve(undefined);
      });
    },
    removeEventListener: function removeEventListener(type, listener, callback) {
      return new Promise(function (resolve) {
        var _eventMap$type;
        eventMap[type] = (_eventMap$type = eventMap[type]) === null || _eventMap$type === void 0 ? void 0 : _eventMap$type.filter(function (item) {
          return item !== listener;
        });
        callback === null || callback === void 0 ? void 0 : callback();
        resolve(undefined);
      });
    },
    dispatchEvent: function dispatchEvent(options) {
      return new Promise(function (resolve) {
        var _eventMap$options$typ;
        (_eventMap$options$typ = eventMap[options.type]) === null || _eventMap$options$typ === void 0 ? void 0 : _eventMap$options$typ.forEach(function (func) {
          func();
        });
        resolve(undefined);
      });
    }
  };
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      yodaBridge.event.dispatchEvent({
        type: 'resume'
      });
    }
  });
  yodaBridge.system = {
    getDeviceInfo: fn,
    getAppInfo: function getAppInfo() {
      return Promise.resolve({});
    },
    getNetworkType: fn
  };
  yodaBridge.tool = {
    canIUse: fn,
    checkAppInstalled: fn,
    launchApp: function launchApp(options) {
      return new Promise(function (resolve) {
        window.open(options.scheme);
        resolve(undefined);
      });
    },
    getKswitchData: fn
  };
  yodaBridge.ui = {
    setTitle: fn,
    setTopBarStyle: fn,
    getTopBarStyle: fn,
    setTopBarButton: fn,
    removeTopBarButton: fn,
    setSlideBackBehavior: fn,
    setPhysicalBackBtnBehavior: fn,
    setBounceStyle: fn,
    stopPullDown: fn
  };
  yodaBridge.component = {
    launchIAP: fn,
    getProductLocalCurrencyAndPrice: fn,
    initIAP: fn,
    login: fn,
    bindPhone: fn,
    pasteboard: function () {
      var _pasteboard = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var _navigator$clipboard;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (navigator.clipboard) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", {
                  result: false
                });
              case 2:
                _context.next = 4;
                return (_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText(params.param.pasteString);
              case 4:
                return _context.abrupt("return", {
                  result: true
                });
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function pasteboard(_x) {
        return _pasteboard.apply(this, arguments);
      }
      return pasteboard;
    }(),
    hasInstalledApp: fn,
    hasenvtags: fn
  };
  yodaBridge.merchant = {
    jumpEcomSingleColumnPhoto: fn
  };
  yodaBridge.live = {
    getLiveRoomInfo: fn
  };
}
if (yodaBridge) {
  _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!yodaBridge) {
              _context2.next = 8;
              break;
            }
            _context2.next = 3;
            return yodaBridge.ready();
          case 3:
            yodaBridge.register({
              namespace: 'component',
              name: 'login'
            });
            yodaBridge.register({
              namespace: 'component',
              name: 'share'
            });
            yodaBridge.register({
              namespace: 'component',
              name: 'directShare'
            });
            yodaBridge.register({
              namespace: 'component',
              name: 'hasInstalledApp'
            });
            yodaBridge.register({
              namespace: 'component',
              name: 'bindPhone'
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }))();
}
export { yodaBridge };
/**
 *
 * @param url 打开的链接
 * @param options webview 相关的配置
 * @param query 需要拼接在url上的参数
 */
export function openWebview(url) {
  var needClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var queryStr = 'webview=yoda';
  var joiner = url.indexOf('?') !== -1 ? '&' : '?';
  url += joiner + queryStr;
  var defaultOptions = {
    topBarBgColor: '#f7f7fa',
    webviewBgColor: '#fff',
    titleColor: '#222222',
    topBarPosition: 'default',
    statusBarColorType: 'dark'
  };
  var launchOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
  try {
    yodaBridge.webview.open({
      url: url,
      launchOptions: launchOptions,
      needClose: needClose
    });
    if (yodaBridge.isInYoda && needClose) {
      closeWebview();
    }
  } catch (error) {
    //
  }
}
/**
 *
 * @param jumpUrl 跳转链接
 * @param photoId 短视频id
 * @param cursor 分页游标
 */
function jumpEcomSingleColumnPhoto(jumpUrl, photoId, cursor) {
  try {
    yodaBridge.merchant.jumpEcomSingleColumnPhoto({
      tag: 'RECO',
      photoId: photoId,
      cursor: cursor,
      operationSource: 'encourageKwaiShop',
      bizScene: 'ec',
      bizSource: 'encourageKwaiShop'
    }).then(function (res) {
      console.info(res);
    }).catch(function () {
      // ikwai协议兜底跳转
      window.location.href = "ikwai://work/".concat(jumpUrl, "?operation_source=encourageKwaiShop");
    });
  } catch (error) {
    //
  }
}
/**
 * 打开新的页面
 * 若URL中存在Webview=yoda参数 则使用Yoda容器打开 若不存在则使用Ks容器打开
 * @param url 链接地址
 */
export var openStaticPage = function openStaticPage(url) {
  if (!url) return;
  if (isIOS || url.includes('webview=yoda')) {
    return openWebview(url);
  }
  window.location.href = url;
};
export var closeWebview = function closeWebview() {
  try {
    var _yodaBridge$webview;
    yodaBridge === null || yodaBridge === void 0 ? void 0 : (_yodaBridge$webview = yodaBridge.webview) === null || _yodaBridge$webview === void 0 ? void 0 : _yodaBridge$webview.close();
  } catch (error) {
    //
  }
};
var _paymentSdk;
function getPaymentSdk() {
  return _getPaymentSdk.apply(this, arguments);
} // 跳转端外支付页
function _getPaymentSdk() {
  _getPaymentSdk = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    var OverseaPaymentSdk, countryCode;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (_paymentSdk) {
              _context9.next = 18;
              break;
            }
            _context9.next = 3;
            return import( /* webpackChunkName: "oversea-payment-sdk" */'@kspay/oversea-payment-sdk');
          case 3:
            _context9.next = 5;
            return _context9.sent.default;
          case 5:
            OverseaPaymentSdk = _context9.sent;
            countryCode = '';
            _context9.prev = 7;
            _context9.next = 10;
            return getUserCountryByUid({
              userId: userId
            });
          case 10:
            countryCode = _context9.sent.data.countryCode3Digits;
            _context9.next = 16;
            break;
          case 13:
            _context9.prev = 13;
            _context9.t0 = _context9["catch"](7);
            logger.sendClick({
              radarName: 'withdraw_getUserCountryByUid_error',
              params: {
                error: _context9.t0
              }
            });
          case 16:
            logger.sendClick({
              radarName: 'OverseaPaymentSdk-参数',
              params: {
                country: countryCode,
                env: getEnv()
              }
            });
            _paymentSdk = new OverseaPaymentSdk({
              country: countryCode,
              yoda: yodaBridge,
              env: getEnv()
            });
            // await _paymentSdk.init().catch((e: any) => console.error('paymentSdk init error', e));
          case 18:
            return _context9.abrupt("return", _paymentSdk);
          case 19:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[7, 13]]);
  }));
  return _getPaymentSdk.apply(this, arguments);
}
export var jumpOutterPay = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(path) {
    var pn, _yodaBridge$tool, keys, r, noValues, errText, text, ck, url;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getMaskPhone();
          case 2:
            pn = _context3.sent;
            if (!pn) {
              _context3.next = 18;
              break;
            }
            keys = ['kwaipro.api_st', 'countryInfo', 'appName', 'sys', 'bucket', 'kuaishou.oversea.im_st', 'appver', 'userId', 'kpn', 'passToken', 'token', 'did', 'language'];
            r = '';
            noValues = [];
            keys.forEach(function (k) {
              var v = Cookies.get(k);
              if (v && v !== 'undefined') {
                r += "".concat(k, "=").concat(v, ";");
              } else {
                noValues.push(k);
              }
            });
            if (!noValues.includes('token')) {
              _context3.next = 13;
              break;
            }
            errText = 'token error';
            try {
              text = Vue.prototype.$k18n({
                id: 'error_to_customer'
              });
              errText = text && text !== 'error_to_customer' ? text : errText;
            } catch (error) {
              //
            }
            Toast.info(errText);
            return _context3.abrupt("return");
          case 13:
            ck = encodeURI(r);
            url = "".concat(path, "?source=transfer&ck=").concat(ck);
            yodaBridge === null || yodaBridge === void 0 ? void 0 : (_yodaBridge$tool = yodaBridge.tool) === null || _yodaBridge$tool === void 0 ? void 0 : _yodaBridge$tool.launchApp({
              scheme: url
            });
            _context3.next = 19;
            break;
          case 18:
            yodaBridge === null || yodaBridge === void 0 ? void 0 : yodaBridge.component.bindPhone();
          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function jumpOutterPay(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var gotoPay = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(withdrawParams) {
    var errText, text, paymentSdk;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            logger.sendClick({
              radarName: '提现-传入参数',
              params: withdrawParams
            });
            if (withdrawParams.account_group_key) {
              _context4.next = 6;
              break;
            }
            errText = 'invalid key';
            try {
              text = Vue.prototype.$k18n({
                id: 'error_to_customer'
              });
              errText = text && text !== 'error_to_customer' ? text : errText;
            } catch (error) {
              //
            }
            Toast.info(errText);
            return _context4.abrupt("return");
          case 6:
            _context4.prev = 6;
            _context4.next = 9;
            return getPaymentSdk();
          case 9:
            paymentSdk = _context4.sent;
            _context4.next = 12;
            return paymentSdk === null || paymentSdk === void 0 ? void 0 : paymentSdk.init(withdrawParams.account_group_key);
          case 12:
            _context4.next = 14;
            return paymentSdk === null || paymentSdk === void 0 ? void 0 : paymentSdk.withdraw(withdrawParams);
          case 14:
            _context4.next = 19;
            break;
          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](6);
            //
            logger.sendClick({
              radarName: '提现-SDK错误',
              params: {
                error: JSON.stringify(_context4.t0)
              }
            });
          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[6, 16]]);
  }));
  return function gotoPay(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var gotoRecharge = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(rechargeParams) {
    var paymentSdk;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return getPaymentSdk();
          case 3:
            paymentSdk = _context5.sent;
            _context5.next = 6;
            return paymentSdk.init(rechargeParams.exchange_gift_card_config_key);
          case 6:
            _context5.next = 8;
            return paymentSdk.recharge(rechargeParams);
          case 8:
            _context5.next = 13;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            //
            logger.sendClick({
              radarName: 'gotoRecharge-SDK错误',
              params: {
                error: _context5.t0
              }
            });
          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));
  return function gotoRecharge(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var gotoGiftcard = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(giftcardParams) {
    var paymentSdk;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return getPaymentSdk();
          case 3:
            paymentSdk = _context6.sent;
            _context6.next = 6;
            return paymentSdk.init(giftcardParams.exchange_gift_card_config_key);
          case 6:
            _context6.next = 8;
            return paymentSdk.giftcard(giftcardParams);
          case 8:
            _context6.next = 13;
            break;
          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            //
            logger.sendClick({
              radarName: 'gotoGiftcard-SDK错误',
              params: {
                error: _context6.t0
              }
            });
          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }));
  return function gotoGiftcard(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var gotoResult = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(resultParams) {
    var paymentSdk;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return getPaymentSdk();
          case 3:
            paymentSdk = _context7.sent;
            _context7.next = 6;
            return paymentSdk.init('');
          case 6:
            _context7.next = 8;
            return paymentSdk.result(resultParams);
          case 8:
            _context7.next = 13;
            break;
          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7["catch"](0);
            //
            logger.sendClick({
              radarName: 'gotoResult-SDK错误',
              params: {
                error: _context7.t0
              }
            });
          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 10]]);
  }));
  return function gotoResult(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var gotoUnbind = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(params) {
    var paymentSdk;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return getPaymentSdk();
          case 3:
            paymentSdk = _context8.sent;
            _context8.next = 6;
            return paymentSdk.init('');
          case 6:
            _context8.next = 8;
            return paymentSdk.unbind(params);
          case 8:
            _context8.next = 13;
            break;
          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](0);
            //
            logger.sendClick({
              radarName: 'gotoUnbind-SDK错误',
              params: {
                error: _context8.t0
              }
            });
          case 13:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 10]]);
  }));
  return function gotoUnbind(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
// 跳转其它页面
export var jumpTo = function jumpTo(jumpType, jumpUrl, photoId, cursor) {
  var _yodaBridge$tool2;
  switch (jumpType) {
    // webview内跳转h5页面
    case IJumpType.KWAI_H5:
      openWebview(jumpUrl);
      break;
    // 系统浏览器跳转h5页面
    case IJumpType.OUTSIDE_WEB:
      yodaBridge === null || yodaBridge === void 0 ? void 0 : (_yodaBridge$tool2 = yodaBridge.tool) === null || _yodaBridge$tool2 === void 0 ? void 0 : _yodaBridge$tool2.launchApp({
        scheme: jumpUrl
      });
      break;
    // 跳转直播间
    case IJumpType.LIVE:
      window.location.href = "ikwai://live/play/".concat(jumpUrl, "?operation_source=encourageKwaiShop&end_to_profile=true&route_to_slide=true&live_source=encourageKwaiShop&requestType=29");
      break;
    // 跳转到短视频
    case IJumpType.PHOTO:
      jumpEcomSingleColumnPhoto(jumpUrl, photoId, cursor);
      break;
    // 跳转到hashtag
    case IJumpType.HashTag:
      window.location.href = "ikwai://tag/topic/".concat(jumpUrl, "?operation_source=encourageKwaiShop");
      break;
    default:
      break;
  }
};